import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/Login";
import Admin from "@/components/Admin";

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "scheduler",
      component: Admin,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        guest: true
      }
    },
    {
      path: "/admin",
      name: "admin",
      component: Admin,
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem("jwt") !== null) {
      next();
    } else next({ name: "login" });
  } else {
    if (to.name == "login" && localStorage.getItem("jwt") !== null) {
      next({ name: "scheduler" });
    } else next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js